module.exports = __webpack_public_path__ + "img/No_data.afdbb3db.svg";